import React from 'react';
import { Card, Typography } from 'antd';
import ReferralLinkGenerator from '../components/ReferralLinkGenerator';

const { Title, Paragraph } = Typography;

const ReferralPage: React.FC = () => {
  return (
    <Card>
      <Typography>
        <Title level={2}>推广管理</Title>
        <Paragraph>
          点击下方按钮生成您的专属推广链接。用户通过您的推广链接访问并连接钱包后，系统将自动记录您作为推荐人。
        </Paragraph>
      </Typography>
      <ReferralLinkGenerator />
    </Card>
  );
};

export default ReferralPage; 